var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3757 8.75134H17.2061C17.0828 8.75134 16.965 8.80491 16.8819 8.89866L11.0186 15.6567V0.573661C11.0186 0.455804 10.9221 0.359375 10.8043 0.359375H9.19712C9.07927 0.359375 8.98284 0.455804 8.98284 0.573661V15.6567L3.11945 8.89866C3.03909 8.80491 2.92123 8.75134 2.79534 8.75134H0.625695C0.443552 8.75134 0.344445 8.9683 0.464981 9.10491L9.35516 19.3504C9.43552 19.4432 9.53487 19.5175 9.64648 19.5685C9.75809 19.6194 9.87934 19.6458 10.002 19.6458C10.1247 19.6458 10.246 19.6194 10.3576 19.5685C10.4692 19.5175 10.5685 19.4432 10.6489 19.3504L19.5364 9.10491C19.6569 8.96562 19.5578 8.75134 19.3757 8.75134Z",
    fill: "#096DD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.662de21f8ef819334a66e974d8103127.svg";
export { ForwardRef as ReactComponent };